module.exports = __webpack_public_path__ + "static/mediacje-78ef716c7709d617d553796f53d972d8.pdf";